import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { BaseRestService } from './base-rest.service';
import { IWorkflowTriggerList, WorkflowTrigger } from '../models/workflow-trigger';
import { SubjectTypeService } from './subject-type.service';
import { LookupService } from './lookup.service';
@Injectable({ providedIn: 'root'})
export class WorkflowTriggerService extends BaseRestService<WorkflowTrigger, IWorkflowTriggerList>{

  //
  // PJT - Please note that work flow triggers are added by the GetDefaultData API call
  // and this endpoint does not get called and does not exist.
  //
  constructor(http: HttpClient, protected router: Router) {
    super(WorkflowTriggerService, http, 'api/workflowtriggers', 'workflow trigger', router);

    // enable caching
    this.cacheEnabled = true;
  }
}
